module.exports = __webpack_public_path__ + "static/media/strawberry_256x256.4892cba8.png";